<template>
  <div class="common-layout">
    <template v-if="!isLoginPage">
      <el-container style="height: 100vh; display: flex; flex-direction: column;">
        <el-header height="60px" style="flex-shrink: 0;">
          <div class="header-container">
            <AnnouncementBar />
          </div>
        </el-header>
        <el-container style="flex: 1; height: calc(100vh - 90px);">
          <!-- 左侧菜单 暂时移除 -->
          <!-- <el-aside width="160px" style="height: 100%;">
            <MenuNavigation />
          </el-aside> -->
          <el-container style="height: 100%; overflow: hidden;">
            <el-main class="main-container">
              <router-view />
            </el-main>
            <el-footer height="auto">
              <div class="footer-container">
                <FooterBar />
              </div>
            </el-footer>
          </el-container>
        </el-container>
      </el-container>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import MenuNavigation from '@/components/navigation/MenuNavigation.vue'
import AnnouncementBar from '@/components/navigation/AnnouncementBar.vue'
import FooterBar from '@/components/navigation/FooterBar.vue'

const route = useRoute()
const isLoginPage = computed(() => route.meta.isLoginPage)
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 150px;
  min-height: 400px;
}
.header-container {
  height: 60px;
  background-color: rgb(250, 250, 250);
}
.footer-container {
  height: 30px;
  background-color: rgb(250, 250, 250);
}
</style>
<style>
.main-container {
  height: 100%;
  width: 100%;
  overflow: auto;
}
/* 通用清除浏览器默认样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
